import { render, staticRenderFns } from "./ThermalStandardization.vue?vue&type=template&id=3a3d8619&"
import script from "./ThermalStandardization.vue?vue&type=script&lang=js&"
export * from "./ThermalStandardization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports